
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/glossary",
      function () {
        return require("private-next-pages/learn/glossary/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/glossary"])
      });
    }
  